
// Sticky Header
jQuery(function($){
	function generateSidePanel(sidePanel, buttonText=null) {
		// generate a unique id for the panel
		let panelID = 'side-panel-'+Math.floor(Math.random() * 1000000);
		let button = $('<button class="btn-collapse" aria-label="Open side panel" aria-controls="'+panelID+'">'+buttonText+'</button>');
		let close = $('<button class="btn-close" aria-label="Close side panel"></button>');
		sidePanel.after(button);
		sidePanel.prepend(close);
		// add aria attributes
		sidePanel.attr('id', panelID);
		sidePanel.attr('aria-hidden', 'true');
		button.attr('aria-expanded', 'false');
		button.click(function(){
			sidePanel.toggleClass('active');
			$('body').toggleClass('side-panel-active');
			// toggle aria attributes
			if ( sidePanel.hasClass('active') ) {
				sidePanel.attr('aria-hidden', 'false');
				button.attr('aria-expanded', 'true');
				let tabbable = sidePanel.find('[tabindex]:not([tabindex="-1"]), a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
				let firstTabbable = tabbable.first();
				let lastTabbable = tabbable.last();
				firstTabbable.focus();
				lastTabbable.keydown(function(e){
					if ( e.keyCode === 9 && !e.shiftKey ) {
						e.preventDefault();
						firstTabbable.focus();
					}
				});
			} else {
				sidePanel.attr('aria-hidden', 'true');
				button.attr('aria-expanded', 'false');
			}
	
		});
		// enter key
		button.keyup(function(e){
			if ( e.keyCode === 13 ) {
				sidePanel.toggleClass('active');
				$('body').toggleClass('side-panel-active');
				// toggle aria attributes
				if ( sidePanel.hasClass('active') ) {
					sidePanel.attr('aria-hidden', 'false');
					button.attr('aria-expanded', 'true');
					let tabbable = sidePanel.find('[tabindex]:not([tabindex="-1"]), a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
					let firstTabbable = tabbable.first();
					let lastTabbable = tabbable.last();
					firstTabbable.focus();
					lastTabbable.keydown(function(e){
						if ( e.keyCode === 9 && !e.shiftKey ) {
							e.preventDefault();
							firstTabbable.focus();
						}
					});
				} else {
					sidePanel.attr('aria-hidden', 'true');
					button.attr('aria-expanded', 'false');
				}
			}
		});
		close.click(function(){
			sidePanel.removeClass('active');
			$('body').removeClass('side-panel-active');
			// toggle aria attributes
			sidePanel.attr('aria-hidden', 'true');
			button.attr('aria-expanded', 'false');
			// move focus to the button
			button.focus();
		});
		// escape key
		$(document).keyup(function(e){
			if ( e.keyCode === 27 ) {
				// toggle aria attributes
				sidePanel.attr('aria-hidden', 'true');
				button.attr('aria-expanded', 'false');
				sidePanel.removeClass('active');
				$('body').removeClass('side-panel-active');
				// move focus to the button
				button.focus();
			}
		});
		// click outside
		$(document).mouseup(function(e){
			// if only sidepanel is active
			if ( !sidePanel.is(e.target) && sidePanel.hasClass('active') && sidePanel.has(e.target).length === 0 ) {
				// toggle aria attributes
				sidePanel.attr('aria-hidden', 'true');
				button.attr('aria-expanded', 'false');
				sidePanel.removeClass('active');
				$('body').removeClass('side-panel-active');
				button.focus();
			}
		});
		return panelID;
	}
	
	
	// Sidebar Toggle
	function toggleSidebar(){
		var sidebar = document.getElementById('pirmary-sidebar');
		var button = document.getElementById('sidebar-toggle');
		var expanded = button.getAttribute('aria-expanded');
		var str = (expanded == 'true') ? 'Open' : 'Collapse Menu';
	
		if( expanded === 'true' ) {
			button.setAttribute('aria-expanded', false);
		} else {
			button.setAttribute('aria-expanded', true);
		}
	
		sidebar.classList.toggle("expanded");
		button.classList.toggle("expanded");
		button.innerText = str;
	}
	
	// More Menu Toggle
	function toggleMore(){
		var footer = $('#npp-footer');
		var button = $('#more-toggle');
		var screen = $('#close-screen');
		var expanded = button.attr('aria-expanded');
		var str = (expanded == 'true') ? 'More' : '';
		var svgIcon = '<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9991 15.6085L1.18984 0.799173" stroke="#0D518B" stroke-linecap="square"/><path d="M1.78221 15.6085L16.5915 0.799154" stroke="#0D518B" stroke-linecap="square"/></svg>';
		var closeButton = $('<button class="btn-close" aria-label="Close side panel">' + svgIcon + '</button>');
		if (expanded === 'true') {
		  button.attr('aria-expanded', false);
		  screen.attr('aria-expanded', false);
		  footer.addClass('collapsing');
		  footer.attr('aria-hidden', true);
		  footer.find('.btn-close').remove();
		  button.focus();
		} else {
		  button.attr('aria-expanded', true);
		  screen.attr('aria-expanded', true);
		  footer.attr('aria-hidden', false);
		  footer.prepend(closeButton);
		  // Delay focus to ensure the element is available
		  setTimeout(function() {
			  // focus on first tabbable element
			let tabbable = footer.find('[tabindex]:not([tabindex="-1"]), a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
			let firstTabbable = tabbable.first();
			let lastTabbable = tabbable.last();
			firstTabbable.focus();
			lastTabbable.keydown(function(e){
				if ( e.keyCode === 9 && !e.shiftKey ) {
					e.preventDefault();
					firstTabbable.focus();
				}	
			});
		  }, 10);
		}
		closeButton.click(function() {
			toggleMore();
		});
		// close on escape key
		$(document).keyup(function(e){
			if ( e.keyCode === 27 ) {
				toggleMore();
			}
		});
		footer.toggleClass('expanded');
		button.toggleClass('expanded');
		screen.toggleClass('expanded');
		button.text(str);
		footer.removeClass('collapsing');
	}
	
	function toggleOnOff(){
		var menuCoontainer = document.querySelector('#menu-container-id');
		var siteHeaderMenuID = menuCoontainer.querySelector('#site-header-menu');
	
		if( siteHeaderMenuID.classList.contains('slide-down') ) {
			siteHeaderMenuID.classList.add('slide-up');
			siteHeaderMenuID.classList.remove('slide-down');
		} else {
			siteHeaderMenuID.classList.add('slide-down');
		}
	
		setTimeout(() => {
			siteHeaderMenuID.classList.remove('slide-up');
		}, "500");
	}

	function navbarheight() {
		return $('.site-header').height();
	}

	// Header Scroll
	var didScroll = false,
		lastScrollTop = 0,
		delta = 5,
		navbarHeight = navbarheight();

	$(window).scroll(function(){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		if( st > navbarHeight ) {

			if (st > lastScrollTop && ! $('.site-header .nav-menu').hasClass('active') ){
				// Scroll Down
				$('body').removeClass('nav-down').addClass('nav-up');
			} else {
				// Scroll Up
				if(st + $(window).height() < $(document).height()) {
					$('body').removeClass('nav-up').addClass('nav-down');
				}
			}

		} else {
			$('body').removeClass('nav-down').removeClass('nav-up');
		}
		lastScrollTop = st;
	}

	$('.backtotop').click(function(){
		$('body').removeClass('nav-up').removeClass('nav-down');
	});
	/*
	Alert's
	*/
	$('.close').click(function(){
		console.log(eqd_vars.ajax_url);
		$.ajax({
			url: eqd_vars.ajax_url,
			type: 'POST',
			data: {
				action: 'npp_dismiss_alert',
				alert_id: $(this).data('alert-id'),
				nonce: eqd_vars.nonce,
			},
			success: function(data) {
			},
		});
		$(this).parent().fadeOut("normal", function() {
			$(this).remove();
		});
	});
	if ( $( '.wpas-status-open' ).length ) {
		$( '.wpas-status-open' ).each(function(){
			let text = $(this).find('.wpas-label').text();
			if ( 'New' === text ) {
				$(this).addClass('wpas-status-new');
			}
		});
	}
	
	// on mobile only
	if ( $(window).width() <= 1024 ) {
		// any element with data-collapse.
		$('[data-collapse]').each(function(){
			let sidePanel = $(this);			
			let buttonText = $(this).data('collapse');
			generateSidePanel(sidePanel, buttonText);
		});
	}
	$('.screen-close').click(function(){
		toggleMore();
	});
	$('.toggle-more').click(function(){
		toggleMore();
	});
	$(".toggle-sidebar").click(function(){
		toggleSidebar();
	});
	let inputField = document.getElementById('orders-form-search');
	if ( inputField ) {
		let inputFieldLabel = document.getElementById('orders-form-search-label');
		inputField.addEventListener('focus', () => {
			inputFieldLabel.classList.add('focused');
		});
		inputField.addEventListener('blur', () => {
			inputFieldLabel.classList.remove('focused');
		});
	}
	$("#resend_verification_link").click(function(){
		$("#resend_verification_link").text('Sending...');
		$("#resend_verification_link").attr('disabled', 'disabled');
		$("#resend_verification_link").addClass('disabled');
		jQuery.post(eqd_vars.ajax_url, {action: "resend_verification_link", user_id: $(this).data('user-id'), nonce: eqd_vars.nonce }, function(response){
			if ( response.success ) {
				$("#resend_verification_link").text('Verification link sent');
				$("#resend_verification_link").removeClass('disabled');
				$("#resend_verification_link").removeAttr('disabled');
			} else {
				$("#resend_verification_link").text('Error sending link');
				$("#resend_verification_link").removeClass('disabled');
				$("#resend_verification_link").removeAttr('disabled');
			}
			setTimeout(function(){
				$("#resend_verification_link").text('Resend verification link');
			}, 3000);
		});
	});
	// $('.page-template-create-account .gfield_radio').each(function(){
	// 	// set first $(this).find('.gchoice') as current and checked
	// 	$(this).find('.gchoice').first().addClass('current');
	// });
	$('.page-template-create-account .gfield_radio .gchoice').click(function(){
		$(this).parent().find('.gchoice').removeClass('current');
		$(this).addClass('current');
	});

	// change gsection_title to h2
	$('.gsection .gsection_title').each(function() {
        var content = $(this).html();
        var h2 = $('<h2/>').html(content);
        $(this).replaceWith(h2);
    });
	// menu-container remove if empty
	$('.menu-container').each(function(){
		if ( $(this).find('.menu-item').length === 0 ) {
			$(this).remove();
		}
	});	
});


// User Role Parameter
var url = window.location.search;
var roleParam = new URLSearchParams(url);
var user = roleParam.get('role')
var bodyElem = document.getElementsByTagName('body');
bodyElem[0].classList.add('page-success__body-role-' + user);

/**
 * Handle the accept order status
 * 
 * assigned, already-assigned, not-allowed-facility, not-allowed-role
 * 
 */
document.addEventListener('DOMContentLoaded', function() {
	var urlParams = new URLSearchParams(window.location.search);
	var status = urlParams.get('status');

	switch (status) {
		case 'assigned':
			alert('Order accepted successfully');
			break;
		case 'already-assigned-to-user':
			alert('Order already assigned to you');
			break;
		case 'already-assigned':
			alert('Order already assigned to another nurse');
			break;
		case 'not-allowed-facility':
			alert('Order is not assigned to your facility');
			break;
		case 'not-allowed-role':
			alert('You do not have permission to accept orders');
			break;
	}

	// Remove the status parameter from the URL without reloading the page
	if (status) {
		urlParams.delete('status'); // Delete the status parameter
		var newPath = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
		window.history.replaceState({}, document.title, newPath);
	}
});
